var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-icon",class:_vm.size},[_c('div',{staticClass:"image",style:({ backgroundImage: ("url(" + (_vm.resolve(_vm.item)) + ")") })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /home/pablo/vortex/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76adf86c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/pablo/vortex/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!/home/pablo/vortex/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon.vue
// module id = null
// module chunks = 